import React from 'react';
import hoverManager from '../../../utils/HoverManager';
import mouseUtils from '../../../utils/MouseUtils';
import mindMapUtils from '../../../utils/MindMapUtils';

const Button = React.createClass({
    getInitialState() {
        return {
            isOver: false
        };
    },
    onMouseIn() {
        this.setState({
            isOver: true
        });
    },
    onMouseOut() {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.index === 0)
            mindMapUtils.openSearchForImageInsertion(this.props.contextTarget.uuid);
        else {
            mindMapUtils.removeImage(this.props.contextTarget.uuid);

            if (this.props.forceUpdateTextEditor)
                this.props.forceUpdateTextEditor();

            let firstFocusableElement = document.getElementById('firstFocusableObjectForTextEditorTool');

            if (firstFocusableElement)
                firstFocusableElement.focus();
        }
    },
    getLefPosition() {
        let leftPosition = 0;
        let buttonSize = this.props.width;
        let gap = this.props.gap;

        switch (this.props.index) {
            case 0: {
                leftPosition = 0;
                break;
            }
            case 1: {
                leftPosition = buttonSize + gap;
                break;
            }
        }

        return leftPosition;
    },
    getLabel() {
        if (this.props.index === 0) {
            if (this.props.contextTarget.imageNode && this.props.contextTarget.imageNode.length > 0)
                return hoverManager.getText('replaceImage');
            else
                return hoverManager.getText('insertImage');
        } else
            return hoverManager.getText('removeImage');
    },
    getIcon() {
        switch(this.props.index) {
            case 0: { // insert image
                return 'fa fa-picture-o';
            }
            case 1: { // delete image
                return 'fa fa-trash';
            }
        }
    },
    render() {
        const buttonWidth = this.props.width;
        const buttonHeight = this.props.height;
        let backgroundColor = this.state.isOver ? '#edefff' : '#f9f9f9';
        let opacity = 1;
        let idValue;
        let tabIndexValue;

        if (this.props.contextTarget.imageNode && this.props.contextTarget.imageNode.length > 0) { // is already an image inserted
            if (this.props.index === 1)
                idValue='lastFocusableObjectForTextEditorTool';
        } else {
            if (this.props.index === 0) {
                idValue='lastFocusableObjectForTextEditorTool';
            } else {
                tabIndexValue = '-1';
                opacity = 0.5;
            }
        }

        let buttonStyle = {
            position: 'absolute',
            top: 0,
            width: buttonWidth,
            height: buttonHeight,
            left: this.getLefPosition(),
            cursor: 'pointer',
            background: backgroundColor,
            borderRadius: 4,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#c4c4c4',
            opacity
        };

        if (opacity === 0.5)
            buttonStyle.pointerEvents = 'none';

        let iconStyle = {
            position: 'absolute',
            top: 5,
            left: 5,
            fontSize: 21,
            pointerEvents: 'none'
        };

        let titleStyle = {
            position: 'absolute',
            top: 10,
            right: 0,
            width: buttonWidth - 33,
            fontSize: 12,
            color: '#000000',
            textAlign: 'center',
            pointerEvents: 'none'
        };

        let icon = this.getIcon();
        let label = this.getLabel();

        return (
            <button id={idValue} tabIndex={tabIndexValue} aria-disabled={tabIndexValue == '-1' ? true : false} aria-label={label} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <i style={iconStyle} className={icon}></i>
                <span style={titleStyle}>{label}</span>
            </button>
        );
    }
});

export const InsertImageArea = React.createClass({
    render() {
        let gap = 10;
        let elementWidth = Math.floor((this.props.width - 3 * gap) / 2);

        let menuStyle = {
            position: 'absolute',
            top: this.props.top,
            left: gap
        };

        return (
            <div style={menuStyle}>
                <Button index={0} width={elementWidth} height={this.props.gridSize} gap={gap} contextTarget={this.props.contextTarget} forceUpdateTextEditor={this.props.forceUpdateTextEditor} />
                <Button index={1} width={elementWidth} height={this.props.gridSize} gap={gap} contextTarget={this.props.contextTarget} forceUpdateTextEditor={this.props.forceUpdateTextEditor} />
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/InsertImageArea.js
 **/